var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "buildSequenceModal",
      attrs: {
        id: "build-sequence-modal",
        "hide-footer": "",
        "hide-header": "",
        "modal-class": "sequence-modal build-sequence-modal",
        centered: "",
      },
      on: { show: _vm.onModalShow, hidden: _vm.resetForm },
    },
    [
      _c("div", { staticClass: "bsm" }, [
        _c(
          "button",
          {
            staticClass: "bsm__close",
            attrs: { type: "button", "aria-label": "Close" },
            on: { click: _vm.closeModal },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M18 6 6 18" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "m6 6 12 12" } }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bsm__header" }, [
          _c("h2", { staticClass: "bsm__title" }, [
            _c(
              "svg",
              {
                staticClass: "bsm__title-icon",
                attrs: {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M10 12h11" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M10 18h11" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M10 6h11" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M4 10h2" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M4 6h1v4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" } }),
              ]
            ),
            _vm._v("\n        Build a Custom Sequence\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "bsm__subtitle" }, [
            _vm._v(
              "\n        Add slots from product images, your files, or by describing what you want.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bsm__body" }, [
          _c("div", { staticClass: "bsm__name-row" }, [
            _c("div", { staticClass: "bsm__name-field" }, [
              _c(
                "label",
                {
                  staticClass: "bsm__label",
                  attrs: { for: "sequence-name-input" },
                },
                [_vm._v("Sequence name")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sequenceName,
                    expression: "sequenceName",
                  },
                ],
                staticClass: "bsm__input",
                attrs: {
                  id: "sequence-name-input",
                  type: "text",
                  placeholder: "e.g. Frozen Meals Standard",
                },
                domProps: { value: _vm.sequenceName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.sequenceName = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "bsm__clear-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.sequenceName = ""
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", { attrs: { d: "M3 6h18" } }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "10", x2: "10", y1: "11", y2: "17" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "14", x2: "14", y1: "11", y2: "17" },
                    }),
                  ]
                ),
                _vm._v("\n          Clear\n        "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bsm__slots-section" }, [
            _c(
              "button",
              {
                staticClass: "bsm__section-toggle",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.slotsExpanded = !_vm.slotsExpanded
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "bsm__chevron",
                    class: { "bsm__chevron--collapsed": !_vm.slotsExpanded },
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "bsm__section-label" }, [
                  _vm._v("Slots (" + _vm._s(_vm.slots.length) + ")"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.slotsExpanded,
                    expression: "slotsExpanded",
                  },
                ],
                staticClass: "bsm__slots-list",
              },
              [
                _vm.slots.length === 0
                  ? _c("div", { staticClass: "bsm__slots-empty" }, [
                      _vm._v(
                        "\n            No slots yet. Add one below.\n          "
                      ),
                    ])
                  : _c(
                      "draggable",
                      {
                        staticClass: "bsm__slots-ul",
                        attrs: {
                          tag: "ul",
                          filter: ".bsm__slot-remove, .bsm__slot-source",
                          "prevent-on-filter": true,
                          animation: 150,
                          "ghost-class": "bsm__slot-row--ghost",
                          "force-fallback": true,
                          "fallback-on-body": true,
                        },
                        model: {
                          value: _vm.slots,
                          callback: function ($$v) {
                            _vm.slots = $$v
                          },
                          expression: "slots",
                        },
                      },
                      _vm._l(_vm.slots, function (slot) {
                        return _c(
                          "li",
                          { key: slot.id, staticClass: "bsm__slot-row group" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "bsm__grip",
                                attrs: {
                                  role: "button",
                                  tabindex: "-1",
                                  "aria-label": "Drag to reorder",
                                  title: "Drag to reorder",
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: { cx: "9", cy: "12", r: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: { cx: "9", cy: "5", r: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: { cx: "9", cy: "19", r: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: { cx: "15", cy: "12", r: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: { cx: "15", cy: "5", r: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: { cx: "15", cy: "19", r: "1" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "bsm__slot-main" }, [
                              slot.imageUrl
                                ? _c("img", {
                                    staticClass: "bsm__slot-thumb",
                                    attrs: {
                                      src: slot.imageUrl,
                                      alt: slot.label,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "bsm__slot-label" }, [
                                _vm._v(_vm._s(slot.label)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "bsm__slot-source",
                                class:
                                  _vm.slotSource(slot) === "upload"
                                    ? "bsm__slot-source--upload"
                                    : "bsm__slot-source--ai",
                                attrs: {
                                  type: "button",
                                  "aria-label": _vm.slotSourceTooltip(slot),
                                  title: _vm.slotSourceTooltip(slot),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleSlotSource(slot.id)
                                  },
                                },
                              },
                              [
                                _vm.slotSource(slot) === "upload"
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("rect", {
                                          attrs: {
                                            x: "3",
                                            y: "3",
                                            width: "18",
                                            height: "18",
                                            rx: "2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("circle", {
                                          attrs: { cx: "9", cy: "9", r: "2" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "currentColor",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M9 2 10.6 6.4 15 8l-4.4 1.6L9 14l-1.6-4.4L3 8l4.4-1.6L9 2Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M17.5 12.5l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9.9-2.6Z",
                                          },
                                        }),
                                      ]
                                    ),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.slotSource(slot) === "upload"
                                        ? "Upload"
                                        : "AI"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "bsm__slot-remove",
                                attrs: {
                                  type: "button",
                                  "aria-label": "Remove slot",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeSlot(slot.id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", { attrs: { d: "M18 6 6 18" } }),
                                    _vm._v(" "),
                                    _c("path", { attrs: { d: "m6 6 12 12" } }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bsm__add-type-row" }, [
            _c(
              "div",
              { ref: "typeDropdown", staticClass: "bsm__select-wrap" },
              [
                _c(
                  "button",
                  {
                    staticClass: "bsm__type-trigger",
                    class: { "bsm__type-trigger--open": _vm.typeDropdownOpen },
                    attrs: {
                      type: "button",
                      "aria-haspopup": "listbox",
                      "aria-expanded": _vm.typeDropdownOpen ? "true" : "false",
                    },
                    on: { click: _vm.toggleTypeDropdown },
                  },
                  [_vm._v("\n            + Add image type…\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "bsm__select-chevron",
                    class: {
                      "bsm__select-chevron--open": _vm.typeDropdownOpen,
                    },
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.typeDropdownOpen,
                        expression: "typeDropdownOpen",
                      },
                    ],
                    ref: "typeMenu",
                    staticClass: "bsm__type-menu",
                    attrs: { role: "listbox" },
                  },
                  [
                    !_vm.availableImageTypes.length
                      ? _c("li", { staticClass: "bsm__type-empty" }, [
                          _vm._v(
                            "\n              No more types to add\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.availableImageTypes, function (type) {
                      return _c(
                        "li",
                        {
                          key: type.key,
                          staticClass: "bsm__type-option",
                          attrs: { role: "option" },
                          on: {
                            click: function ($event) {
                              return _vm.selectImageType(type.key)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(type.label) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "bsm__new-type-btn",
                attrs: { type: "button" },
                on: { click: _vm.openDescribeNewType },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", { attrs: { d: "M5 12h14" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M12 5v14" } }),
                  ]
                ),
                _vm._v("\n          New type…\n        "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bsm__more-ways" }, [
            _c(
              "button",
              {
                staticClass: "bsm__section-toggle",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.moreWaysExpanded = !_vm.moreWaysExpanded
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "bsm__chevron",
                    class: { "bsm__chevron--collapsed": !_vm.moreWaysExpanded },
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
                ),
                _vm._v("\n          More ways to add\n        "),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.moreWaysExpanded,
                    expression: "moreWaysExpanded",
                  },
                ],
                staticClass: "bsm__more-ways-content",
              },
              [
                _c("AdvancedSlotAdding", {
                  ref: "advancedSlotAdding",
                  attrs: { "initial-tab": _vm.moreWaysTab },
                  on: {
                    "add-slot": _vm.onAddSlot,
                    "remove-slot": _vm.onRemoveSlot,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bsm__footer" }, [
          _c(
            "button",
            {
              staticClass: "bsm__cancel-btn",
              attrs: { type: "button" },
              on: { click: _vm.closeModal },
            },
            [_vm._v("\n        Cancel\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "bsm__save-btn",
              attrs: { type: "button", disabled: !_vm.canSave || _vm.isSaving },
              on: { click: _vm.saveSequence },
            },
            [
              _vm.isSaving
                ? _c("b-spinner", { attrs: { small: "" } })
                : _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M7 3v4a1 1 0 0 0 1 1h7" } }),
                    ]
                  ),
              _vm._v("\n        Save Sequence\n      "),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }